/**
 * Handle controlled inputs.
 * The "text" action handles text, textarea, radio, date, email, and select inputs.
 */
export interface FormAction {
    type: "reset";
    payload: Record<string, unknown>;
}

export interface TextFormAction {
    type: "text";
    field: string;
    payload: unknown;
}

export type FormActionTypes = FormAction | TextFormAction;

const FormReducer = <T extends Record<string, unknown>>(state: T, action: FormActionTypes): T => {
    if (action.type === "reset") {
        return action.payload as T;
    }
    if (action.type === "text") {
        return { ...state, [action.field]: action.payload };
    }
    return state;
};

export default FormReducer;
